import React, { useState, useEffect, Fragment } from 'react';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row, Input } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { User } from 'react-feather';
import { fetchTableData } from '../../../Api/ApiMethods';
import { useNavigate } from 'react-router-dom';

const LicensePlates = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [filterText, setFilterText] = useState('');

    const licensePlateApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/licenseplate';
    const navigate = useNavigate();

    const handleSearch = (event) => {
        setFilterText(event.target.value);
    };

    useEffect(() => {
        fetchTableData({
            apiEndpoint: licensePlateApiUrl,
            page,
            pageSize,
            search,
            setDataCallback: setData,
            setTotalRowsCallback: setTotalRows,
        });
    }, [page, pageSize, search, licensePlateApiUrl]);

    const handleCustomerDetail = (customerId) => {
        navigate(`/customer/${customerId}`);
    };

    const filteredItems = data.filter(
        item => {
            const searchableValues = [
                item.licensePlateNumber,
                item.licensePlateStatus,
                item.carchassisNumber,
                item.carBrand,
                item.carModel,
                item.carYear,
                item.carOwner,
                item.trafficInsurancePolicy?.trafficInsuranceNumber,
                item.cascoInsurancePolicy?.cascoInsuranceNumber,
                item.description
            ].filter(Boolean).join(' ').toLowerCase();
            
            return searchableValues.includes(filterText.toLowerCase());
        }
    );

    const columns = [
        {
            name: 'Müşteri',
            cell: row => {
                const customerId = row.customer?.[0];
                return customerId ? (
                    <div className="btn btn-outline-primary d-flex align-items-center justify-content-center" onClick={() => handleCustomerDetail(customerId)}>
                        <User size={18}/>
                    </div>
                ) : '';
            },
            ignoreRowClick: true,
            right: true,
            button: true,
        },
        { name: 'Plaka Numarası', selector: row => row.licensePlateNumber || '', sortable: true },
        { name: 'Plaka Durumu', selector: row => row.licensePlateStatus || '', sortable: true },
        { name: 'Şasi Numarası', selector: row => row.carchassisNumber || '', sortable: true },
        { name: 'Araç Markası', selector: row => row.carBrand || '', sortable: true },
        { name: 'Araç Modeli', selector: row => row.carModel || '', sortable: true },
        { name: 'Araç Yılı', selector: row => row.carYear || '', sortable: true },
        { name: 'Araç Sahibi', selector: row => row.carOwner || '', sortable: true },
        { name: 'Trafik Sigortası Numarası', selector: row => row.trafficInsurancePolicy?.trafficInsuranceNumber || '', sortable: true },
        { name: 'Kasko Sigortası Numarası', selector: row => row.cascoInsurancePolicy?.cascoInsuranceNumber || '', sortable: true },
        { name: 'Açıklama', selector: row => row.description || '', sortable: true },
    ];

    return (
        <>
            <Breadcrumbs parent='Müşteri Alanları' title='Plakalar' />
            <Container fluid={true}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardHeader>
                                <H5>Plakalar</H5>
                                <span>Mevcut olan plakalar aşağıda listelenmektedir.</span>
                            </CardHeader>
                            <CardBody>
                                <div className="d-flex justify-content-end align-items-center w-100 file-content">
                                    <div className='form-inline custom-responsive-width'>
                                        <div className='mb-0 form-group'>
                                            <i className='fa fa-search'></i>
                                            <Input type="text" placeholder="Ara.." value={filterText} onChange={handleSearch} className="form-control-plaintext ml-2" />
                                        </div>
                                    </div>
                                </div>

                                <div style={{ height: "40px" }}></div>

                                <Fragment>
                                    <DataTable
                                        columns={columns}
                                        data={filteredItems}
                                        pagination
                                        paginationServer
                                        selectableRows={false}
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setPage(page)}
                                        onChangeRowsPerPage={pageSize => setPageSize(pageSize)}
                                    />
                                </Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default LicensePlates;
